module.exports = isPromise;
module.exports.default = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/is-promise/index.js
 ** module id = 212
 ** module chunks = 0
 **/